/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ContentFavoriteControllerToggleFavorite$Params {
  contentId: string;
  userId: string;
}

export function contentFavoriteControllerToggleFavorite(http: HttpClient, rootUrl: string, params: ContentFavoriteControllerToggleFavorite$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, contentFavoriteControllerToggleFavorite.PATH, 'post');
  if (params) {
    rb.query('contentId', params.contentId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

contentFavoriteControllerToggleFavorite.PATH = '/api/content-favorite';
